import(/* webpackMode: "eager" */ "/site-builder-src/src/app/error.tsx");
